import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../health-dashboard/health-dashboard.action";
import {
  Container,
  Button,
  Icon,
  Grid,
  Dimmer,
  Loader,
  Popup,
  Form,
  Table,
  Sidebar,
  Dropdown,
  Modal,
  Label,
  Segment
} from "semantic-ui-react";
import { CustomHeader, CustomHeaderBold } from "../../components/labels/labels";
import * as commonActions from "../../views/user/common/common.action";

class HealthDashBoard extends Component {
  state = {
    isLoading: "",
    OverAllStat: "",
    isLoad: false,
    day: 0,
    week: 0,
    authWeek: 0,
    orderStatusDay: 0,
    openErrorMessage: false,
    errorMessage: "",
    errorMessageList: []
  };

  componentDidMount() {
    this.props.getApiStatus(1, 1, 1, 1);
    this.setState({ day: 1 });
    this.setState({ week: 1 });
    this.setState({ authWeek: 1 });
    this.setState({ orderStatusDay: 1 });
    this.props.getActivePage("Health Dashboard");
  }

  handleFilter = (property) => {
    const { week, orderStatusDay, authWeek } = this.state;

    this.props.getApiStatus(property.value, week, orderStatusDay, authWeek);
    this.setState({ day: property.value });
  };

  handleFilterByWeek = (property) => {
    const { day, orderStatusDay, authWeek } = this.state;
    this.props.getApiStatus(day, property.value, orderStatusDay, authWeek);
    this.setState({ week: property.value });
  };

  handleAuthLetterFilterByWeek = (property) => {
    const { day, orderStatusDay, week } = this.state;
    this.props.getApiStatus(day, week, orderStatusDay, property.value);
    this.setState({ authWeek: property.value });
  };

  handleFilterOrderStatus = (property) => {
    const { week, day, authWeek } = this.state;

    this.props.getApiStatus(day, week, property.value, authWeek);
    this.setState({ orderStatusDay: property.value });
  };

  handleErrorMessage = (column) => {
    if (column.errorMessage != "Passed") {
      this.setState({ errorMessage: column.errorMessage });
      this.setState({ openErrorMessage: true });
      this.setState({ errorMessageList: column.errorMessageList });
    }
  };

  handleCloseErrorBox = () => {
    this.setState({ openErrorMessage: false });
  };
  render() {
    const { data, filterOptions, filterByWeek, filterByOrderStatus } =
      this.props;
    const {
      OverAllStat,
      isLoad,
      day,
      week,
      authWeek,
      orderStatusDay,
      openErrorMessage,
      errorMessage,
      errorMessageList
    } = this.state;

    if (data && data.data && !isLoad) {
      var redStat = data.data.filter((i) => i.statusResult == 2);
      var amber = data.data.filter((i) => i.statusResult == 1);

      if (amber.length == 1) {
        this.setState({
          OverAllStat: "ui yellow circular label, ui massive label "
        });
      } else if (amber.length > 1) {
        this.setState({
          OverAllStat: "ui red circular label, ui massive label"
        });
      } else if (redStat.length > 0) {
        this.setState({
          OverAllStat: "ui red circular label, ui massive label"
        });
      } else {
        this.setState({
          OverAllStat: "ui green circular label, ui massive label"
        });
      }
      this.setState({ isLoad: true });
    }
    return (
      <div className="container-wrapper">
        <Modal size="small" open={openErrorMessage}>
          <Modal.Header>
            <table>
              <tr>
                <th width="700">Error Message</th>
                <th textAlign="right">
                  <Button primary onClick={() => this.handleCloseErrorBox()}>
                    X
                  </Button>
                </th>
              </tr>
            </table>
          </Modal.Header>
          <Modal.Content>
            <Table basic="very" hidden={errorMessageList == null}>
              <Table.Body>
                {errorMessageList &&
                  errorMessageList.map((column, idx) => {
                    return (
                      <Table.Row>
                        <Table.Cell>{column}</Table.Cell>
                      </Table.Row>
                    );
                  })}
              </Table.Body>
            </Table>
            <span hidden={errorMessageList}>{errorMessage}</span>
          </Modal.Content>
        </Modal>
        <Popup
          trigger={<Icon exclamation name="error" />}
          hoverable
          content="View Error"
          size="mini"
        />
        <Segment fluid>
          <Sidebar.Pushable>
            <Container fluid style={{ padding: "30px" }}>
              <Dimmer active={this.props.loading}>
                <Loader>Loading</Loader>
              </Dimmer>
              <Grid>
                <Grid.Row columns={16}>
                  <Grid.Column width={11}></Grid.Column>
                  <Grid.Column width={5} class="right floated column">
                    <Grid>
                      <Grid.Column
                        width={13}
                        textAlign="right"
                        verticalAlign="middle"
                      >
                        <CustomHeader message="System Status" />
                      </Grid.Column>
                      <Grid.Column>
                        <a class={OverAllStat}></a>
                      </Grid.Column>
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
           
              <Table style={{ tableLayout: 'fixed', width: '100%' }}>
                {/* Define column widths */}
                <colgroup>
                  <col style={{ width: '20%' }} />     {/* Integrations */}
                  <col style={{ width: '8.333%' }} />     {/* Details */}
                  <col style={{ width: '55%' }} />  {/* Error Message */}
                  <col style={{ width: '8.333%' }} />  {/* Filter */}
                  <col style={{ width: '8.333%' }} />  {/* Status */}
                </colgroup>

                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Integrations</Table.HeaderCell>
                    <Table.HeaderCell>Details</Table.HeaderCell>
                    <Table.HeaderCell>Error Message</Table.HeaderCell>
                    <Table.HeaderCell>Filter</Table.HeaderCell>
                    <Table.HeaderCell textAlign="right">Status</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {data?.data?.map((row, idx) => (
                    <Table.Row key={row.id ?? idx}>
                      {/* 1) Integrations */}
                      <Table.Cell>
                        {row.name}
                      </Table.Cell>

                      {/* 2) Details (example: totalFailed or whatever "Details" should be) */}
                      <Table.Cell>
                        {row.totalFailed}
                      </Table.Cell>

                      {/* 3) Error Message */}
                      <Table.Cell>
                        {Array.isArray(row.errorMessageList) && row.errorMessageList.length > 0 ? (
                          <Table basic="very">
                            <Table.Body>
                              {row.errorMessageList.map((msg, i) => (
                                <Table.Row key={i}>
                                  <Table.Cell>{msg}</Table.Cell>
                                </Table.Row>
                              ))}
                            </Table.Body>
                          </Table>
                        ) : (
                          <span>{row.errorMessage}</span>
                        )}
                      </Table.Cell>

                      {/* 4) Filter */}
                      <Table.Cell>
                        {/* Show only the dropdown that applies to this row.id */}
                        {row.id === 1 && (
                          <Form.Field
                            control={Dropdown}
                            compact
                            selection
                            label="Filter by"
                            selectOnBlur={false}
                            placeholder="Filter by"
                            name="filterBy"
                            options={filterOptions}
                            onChange={(e, props) => this.handleFilter(props)}
                            value={day || ''}
                            autoComplete="off"
                          />
                        )}

                        {row.id === 5 && (
                          <Form.Field
                            control={Dropdown}
                            compact
                            selection
                            label="Filter by"
                            selectOnBlur={false}
                            placeholder="Filter by"
                            name="filterBy"
                            options={filterByWeek}
                            onChange={(e, props) => this.handleFilterByWeek(props)}
                            value={week || ''}
                            autoComplete="off"
                          />
                        )}

                        {row.id === 8 && (
                          <Form.Field
                            control={Dropdown}
                            compact
                            selection
                            label="Filter by"
                            selectOnBlur={false}
                            placeholder="Filter by"
                            name="filterBy"
                            options={filterByOrderStatus}
                            onChange={(e, props) => this.handleFilterOrderStatus(props)}
                            value={orderStatusDay || ''}
                            autoComplete="off"
                          />
                        )}

                        {row.id === 10 && (
                          <Form.Field
                            control={Dropdown}
                            compact
                            selection
                            label="Filter by"
                            selectOnBlur={false}
                            placeholder="Filter by"
                            name="filterBy"
                            options={filterByWeek}
                            onChange={(e, props) => this.handleAuthLetterFilterByWeek(props)}
                            value={authWeek || ''}
                            autoComplete="off"
                          />
                        )}
                      </Table.Cell>

                      {/* 5) Status */}
                      <Table.Cell textAlign="right">
                        {row.errorMessage === 'Passed' ? (
                          <a className={row.statusColor} />
                        ) : (
                          <Popup
                            trigger={
                              <i
                                className={row.statusColor}
                                onClick={() => this.handleErrorMessage(row)}
                                style={{ cursor: 'pointer' }}
                              />
                            }
                            content="Please Open a Service Desk ticket for this issue"
                            size="mini"
                          />
                        )}
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>

              <Grid class="ui hidden divider">
                <Grid.Row></Grid.Row>
                <Grid.Row columns={2}>
                  <Grid.Column width={5}>
                    <CustomHeaderBold message="Integrations Health Indicators" />
                  </Grid.Column>
                  <Grid.Column columns={5}>
                    <CustomHeaderBold message="System/ Overall Health Indicators" />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={2}>
                  <Grid.Column width={5}>
                    <Grid>
                      <Grid.Row>
                        <Grid.Column>
                          <a class="ui green circular label"></a>
                        </Grid.Column>
                        <Grid.Column width={10} verticalAlign="middle">
                          Normal System Function
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                  <Grid.Column width={5}>
                    <Grid>
                      <Grid.Row>
                        <Grid.Column>
                          <a class="ui green circular label"></a>
                        </Grid.Column>
                        <Grid.Column width={10} verticalAlign="middle">
                          All integrations are functioning normally
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={2}>
                  <Grid.Column width={5}>
                    <Grid>
                      <Grid.Row>
                        <Grid.Column>
                          <a class="ui yellow circular label"></a>
                        </Grid.Column>
                        <Grid.Column width={10} verticalAlign="middle">
                          Partial system function/ performance issues
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                  <Grid.Column width={5}>
                    <Grid>
                      <Grid.Row>
                        <Grid.Column>
                          <a class="ui yellow circular label"></a>
                        </Grid.Column>
                        <Grid.Column width={15} verticalAlign="middle">
                          1 Integration undergoing partial system function/
                          performance issues
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={2}>
                  <Grid.Column width={5}>
                    <Grid>
                      <Grid.Row>
                        <Grid.Column>
                          <a class="ui red circular label"></a>
                        </Grid.Column>
                        <Grid.Column width={10} verticalAlign="middle">
                          Integration failure
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                  <Grid.Column width={5}>
                    <Grid>
                      <Grid.Row>
                        <Grid.Column>
                          <a class="ui red circular label"></a>
                        </Grid.Column>
                        <Grid.Column width={15} verticalAlign="middle">
                          1+ integrations undergoing failure or 2+ integration
                          partial system function / performance issue or failure
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </Sidebar.Pushable>
        </Segment>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.healthDashBoard.loading,
    data: state.healthDashBoard.data,
    filterOptions: state.healthDashBoard.filterOptions,
    filterByWeek: state.healthDashBoard.filterByWeek,
    filterByOrderStatus: state.healthDashBoard.filterByOrderStatus
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getApiStatus: (day, week, orderStatusDay, authWeek) =>
      dispatch(actions.getApiStatus(day, week, orderStatusDay, authWeek)),
    getActivePage: (page) => dispatch(commonActions.getActivePage(page))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HealthDashBoard);
